import { render, staticRenderFns } from "./SitemapTable.vue?vue&type=template&id=07333f0c&"
import script from "./SitemapTable.vue?vue&type=script&lang=js&"
export * from "./SitemapTable.vue?vue&type=script&lang=js&"
import style0 from "./SitemapTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports